import Vue from 'vue'
import Vuex from 'vuex'

// Ethereum
import Web3 from 'web3';
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
const web3Modal = new Web3Modal({
  network: "kovan", // optional
  cacheProvider: true, // optional
  providerOptions: {
    // Example with WalletConnect provider
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: "27e484dcd9e3efcfd25a83a78777cdf1" // required
      }
    }
  }
});

// NFT Storage
import { NFTStorage, Blob } from 'nft.storage'

const apiKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnaXRodWJ8NzQyNjA5OTciLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYxNzQ3OTU0MjA2NywibmFtZSI6ImRlZmF1bHQifQ.n4qfa-_-IO0x59cFereoob0yfoBFIZ3zGznW_rNyksg'
const client = new NFTStorage({ token: apiKey })


// Ceramic
// import CeramicClient from '@ceramicnetwork/http-client'
// const API_URL = "https://ceramic-clay.3boxlabs.com"
// const ceramic = new CeramicClient(API_URL)
// import { ThreeIdConnect,  EthereumAuthProvider } from '3id-connect'


// import Ceramic from '@ceramicnetwork/core';

// import { ThreeIdConnect, EthereumAuthProvider } from '3id-connect';

// import IPFS from 'ipfs-core'
// import dagJose from 'dag-jose'
// import { sha256 } from 'multiformats/hashes/sha2'
// import legacy from 'multiformats/legacy'

// const hasher = {}
// hasher[sha256.code] = sha256
// const dagJoseFormat = legacy(dagJose, {hashes: hasher})

Vue.use(Vuex)

const ethereum = {
  namespaced: true,
  state: () => ({
    ready: false,
    profile: null,
    storage: {authenticated: false},
    web3: null,
    provider: null,
    constants: {
      token: "0xff795577d9ac8bd7d90ee22b6c1703490b6512fd",
      manager: "aave", // "generic"
      contract: "0x5c72497BE761eDE1C19760a79Ce4c00ad21d7E9b",

    }
  }),
  mutations: {
    setReady(state) {
      if (state.web3 != false) {
        state.ready = true
      }
    },
    setProvider(state, payload) {
      state.provider = payload
    },
    setProfile(state, payload) {
      state.profile = payload
    },
    setStorage(state, payload) {
      state.storage = payload
    },
    setWeb3(state, payload) {
      state.web3 = payload
    }
  },
  actions: {
    init({ state, commit, dispatch }) {

    },
    connect({ commit, dispatch }, accountsChanged, chainChanged, connect, disconnect) {
      return new Promise(async (resolve, reject) => {
        try{
          web3Modal.connect().then(async (provider) => {
            // Subscribe to accounts change
            commit('setProvider', provider)
            provider.on("accountsChanged", (accounts) => {
              if (accountsChanged) {
                accountsChanged()
              }
              web3.eth.getAccounts().then(accounts => {
                commit('setProfile', accounts)
                commit('setReady')
              })
              console.log("Accounts Changed: ", accounts);
            });

            // Subscribe to chainId change
            provider.on("chainChanged", (chainId) => {
              if (chainChanged) {
                chainChanged()
              }
              console.log("Chain Changed: ", chainId);
            });

            // Subscribe to provider connection
            provider.on("connect", (info) => {
              if (connect) {
                connect()
              }
              web3.eth.getAccounts().then(accounts => {
                commit('setProfile', accounts)
                commit('setReady')
              })
              console.log("Connect: ", info);
            });

            // Subscribe to provider disconnection
            provider.on("disconnect", (error) => {
              if (disconnect) {
                disconnect()
              }
              web3.eth.getAccounts().then(accounts => {
                commit('setProfile', accounts)
                commit('setReady')
              })
              commit('setWeb3', null)
              web3Modal.clearCachedProvider()
              console.log("Disconnect: ", error);
            });
            await provider.enable()
            let web3 = new Web3(provider)
            commit('setWeb3', web3);
            web3.eth.getAccounts().then(accounts => {
              commit('setProfile', accounts)
              commit('setReady')
              resolve()
              // dispatch("connectStorage").then(() => {
              //   resolve()
              // })
            })
          })          
        }
        catch(err){
          reject(err)
        }
      })
    },
    disconnect({ commit }) {
      web3Modal.clearCachedProvider()
      commit('setWeb3', null)
    },
    async connectStorage({ state, commit }) {
      return new Promise(async(resolve, reject) => {
        try {
          // const ipfs = await IPFS.create({ ipld: { formats: [dagJoseFormat] } })
          // const ceramic = await Ceramic.create(ipfs)
          const threeIdConnect = new ThreeIdConnect()
          const authProvider = new EthereumAuthProvider(state.provider, state.profile[0])
          await threeIdConnect.connect(authProvider)
          let provider = threeIdConnect.getDidProvider()
          ceramic.setDIDProvider(provider)
          
          console.log("connected to storage")

          commit('setStorage', ceramic)
          commit('setReady')
        } catch (err) {
          reject(err)
        }
      })
    },
    savePublicDocument({state}, payload){
      return new Promise(async(resolve, reject) => {
        let content = new Blob([payload], {type: "application/json"})
        try{
          resolve(await client.storeBlob(content))
        } catch(err) {
          reject(err)
        }
      })
    },
    savePrivateDocument(payload){
      return "https://google.com"
    },
    getTokens({ state }){
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0]
          let protonAbi = await import('@charged-particles/protocol-subgraph/abis/Proton');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let protonAddress = kovanAddresses.proton.address;
          let Proton = new state.web3.eth.Contract(protonAbi.default, protonAddress);
          let n = await Proton.methods.balanceOf(from).call()
          let list = [];
          for(let i = 0; i < n; i++){
            list[list.length] = new Promise((resolve, reject) => {
              Proton.methods.tokenOfOwnerByIndex(from, new state.web3.utils.BN(i)).call().then((ID) => {
                resolve(ID)
              })
            })
          }
          list = await Promise.all(list)
          console.log("List: ", JSON.stringify(list))
          resolve(list)

        } catch(err) {
          reject(err)
        }
      })
    },
    getTokenData({state}, payload){
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0]
          let protonAbi = await import('@charged-particles/protocol-subgraph/abis/Proton');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let protonAddress = kovanAddresses.proton.address;
          let Proton = new state.web3.eth.Contract(protonAbi.default, protonAddress);
          let list = await Proton.methods.tokenURI(payload).call()
          console.log("List: ", JSON.stringify(list))
          resolve(list)

        } catch(err) {
          reject(err)
        }
      })
    },
    getBalances({state}, payload){
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0]
          let chargedParticlesAbi = await import('@charged-particles/protocol-subgraph/abis/ChargedParticles');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let chargedParticlesAddress = kovanAddresses.chargedParticles.address;
          let ChargedParticle = new state.web3.eth.Contract(chargedParticlesAbi.default, chargedParticlesAddress);
          // address contractAddress, uint256 tokenId, string walletManagerId, address assetToken
          let base = await ChargedParticle.methods.baseParticleMass(kovanAddresses.proton.address, payload, state.constants.manager, state.constants.token).call()
          let charge = await ChargedParticle.methods.currentParticleCharge(kovanAddresses.proton.address, payload, state.constants.manager, state.constants.token).call()
          resolve({base: state.web3.utils.fromWei(base), charge: state.web3.utils.fromWei(charge)})

        } catch(err) {
          reject(err)
        }
      })

    },
    // payload: tokenId, assetToken, contract
    getPermissions({state}, payload){
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0]
          let chargedStateAbi = await import('@charged-particles/protocol-subgraph/abis/ChargedState');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let chargedStateAddress = kovanAddresses.chargedState.address;
          let ChargedState = new state.web3.eth.Contract(chargedStateAbi.default, chargedStateAddress);
          // address contractAddress, uint256 tokenId, address operator
          debugger
          let approval = await ChargedState.methods.isApprovedForRelease(kovanAddresses.proton.address, new state.web3.utils.BN(payload.tokenId), state.constants.contract).call()
          resolve(approval)

        } catch(err) {
          reject(err)
        }
      })
    },
    // payload: tokenId, contract
    setPermissions({state}, payload){
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0]
          let chargedStateAbi = await import('@charged-particles/protocol-subgraph/abis/ChargedState');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let chargedStateAddress = kovanAddresses.chargedState.address;
          let ChargedState = new state.web3.eth.Contract(chargedStateAbi.default, chargedStateAddress);
          // address contractAddress, uint256 tokenId, address operator
          let approval = await ChargedState.methods.setApprovalForAll(kovanAddresses.proton.address, new state.web3.utils.BN(payload.tokenId), state.constants.contract).send({from: from})
          resolve(approval)

        } catch(err) {
          reject(err)
        }
      })
    },

    totalDai({ state }) {
      return new Promise(async (resolve, reject) => {
        let abi = await import("@/assets/dai.json")
        abi = JSON.parse(abi.result)
        let daiContract = new state.web3.eth.Contract(abi, state.constants.token)
        let balance = await daiContract.methods.balanceOf(state.profile[0]).call()
        let decimals = await daiContract.methods.decimals().call()
        console.log("Balance: " + balance + " Decimals: " + decimals)
        let total = state.web3.utils.fromWei(balance, 'ether')
        resolve(total)
      })
    },
    //payload: abi, assetToken, contract, assetamount
    approveSpending({state}, payload){
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0];
          let contract = new state.web3.eth.Contract(payload.abi, payload.assetToken)
          let approval = await contract.methods.approve(payload['contract'], state.web3.utils.toWei(new state.web3.utils.BN(payload.assetAmount))).send({from: from})
          resolve(approval)
        }
        catch (err){
          reject(err)
        }
      })
    },

    // payload: url, assetToken, assetAmount
    createCard({ state, dispatch }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          debugger
          let protonAbi = await import('@charged-particles/protocol-subgraph/abis/Proton');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let abi = await import("@/assets/dai.json")
          abi = JSON.parse(abi.result)
          await dispatch('approveSpending',  {abi: abi, assetToken: payload["assetToken"], contract: kovanAddresses.proton.address, assetAmount: payload['assetAmount']})

          let from = state.profile[0]
          let protonAddress = kovanAddresses.proton.address;
          let Proton = new state.web3.eth.Contract(protonAbi.default, protonAddress);

          // address creator, address receiver, address referrer, string tokenMetaUri, string walletManagerId, address assetToken, string assetAmount, string annuityPercent 
          let creator = '0xde9d33c2c79455D9A7DF3450E932599207e231D4' // creator of the token. This person can potentially recieve a cut of the interest 
          let receiver = from // the address of the person the token will be sent to 
          let referrer = '0xde9d33c2c79455D9A7DF3450E932599207e231D4' // referrer may in the future be rewarded by charged.fi
          let meta = payload['url'] // url to the token metadata
          let walletManager = state.constants.manager // the name of the protocol to use to earn a charge. Currently aave, compound and some others I think
          let assetToken = payload["assetToken"] // address of the asset token. So in this case the address of DAI ERC20 token I think
          let assetAmount = new state.web3.utils.BN( state.web3.utils.toWei(payload['assetAmount'])) // amount of the asset to deposit
          let annuityPercent = new state.web3.utils.BN(100) // the percentage of interest to go towards the creator. Add extra 2 zeros, so for 1% -> 100
          // Proton.methods.createProton(creator, receiver, meta, annuityPercent).send({ from: from }).then((newTokenID) => {
          //address creator, address receiver, address referrer, string tokenMetaUri, string walletManagerId, address assetToken, string assetAmount, string annuityPercent
          Proton.methods.createChargedParticle(creator, receiver, referrer, meta, walletManager, assetToken, assetAmount, annuityPercent).send({ from: from }).then((newTokenID) => {
            resolve(newTokenID)
          })
        } catch(err) {
          reject(err)
        }
      })
    },
    // payload: tokenId, manager, assetToken, assetAmount
    stakeToken({state, dispatch}, payload){
      return new Promise(async (resolve, reject) => {
        try {
          debugger
          let from = state.profile[0]
          let chargedParticlesAbi = await import('@charged-particles/protocol-subgraph/abis/ChargedParticles');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let assetToken = '0x4F96Fe3b7A6Cf9725f59d353F723c1bDb64CA6Aa' // address of the asset token. So in this case the address of Dai ERC20 token I think
          let abi = await import("@/assets/dai.json")
          abi = JSON.parse(abi.result)
          await dispatch('approveSpending',  {abi: abi, assetToken: payload["assetToken"], contract: kovanAddresses.chargedParticles.address, assetAmount: payload['assetAmount']})
          
          let ChargedParticle = new state.web3.eth.Contract(chargedParticlesAbi.default, kovanAddresses.chargedParticles.address);
          // address contractAddress, uint256 tokenId, string walletManagerId, address assetToken, uint256 assetAmount, address referrer
          let stake = await ChargedParticle.methods.energizeParticle(kovanAddresses.proton.address, new state.web3.utils.BN(payload["tokenId"]), state.constants.manager, state.constants.token, state.web3.utils.toWei(new state.web3.utils.BN(payload["assetAmount"])), from).send({from: from})
          resolve(stake)

        }
        catch(err) {
          reject(err)
        }
      })
    },
    // payload: tokenId, manager, assetToken
    unstakeToken({state, dispatch}, payload){
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0]
          let chargedParticlesAbi = await import('@charged-particles/protocol-subgraph/abis/ChargedParticles');
          let kovanAddresses = await import('@charged-particles/protocol-subgraph/networks/kovan');
          let chargedParticlesAddress = kovanAddresses.chargedParticles.address;
          let ChargedParticle = new state.web3.eth.Contract(chargedParticlesAbi.default, chargedParticlesAddress);

          //  address receiver, address contractAddress, uint256 tokenId, string walletManagerId, address assetToken
          debugger
          let list = await ChargedParticle.methods.releaseParticle(from, kovanAddresses.proton.address, new state.web3.utils.BN(payload["tokenId"]), state.constants.manager, state.constants.token).send({from: from})
          await dispatch('removeMember', {tokenId: payload["tokenId"] })
          console.log("List: ", JSON.stringify(list))
          resolve(list)

        } catch(err) {
          reject(err)
        }
      })
    },
    //payload: tokenId
    listMembers({state}, payload){
      return new Promise(async (resolve, reject) => { 
        try{
          debugger
          let abi = await import("@/assets/marketplace.json")
          abi = abi.default
          let marketplaceContract = new state.web3.eth.Contract(abi, state.constants.contract)
          let result = await marketplaceContract.methods.listMembers().call()
          resolve(result)
        }
        catch(err){
          reject(err)
        }
      })
    },

    //payload: tokenId
    isMember({state}, payload){
      return new Promise(async (resolve, reject) => { 
        try{
          let from = state.profile[0]
          let abi = await import("@/assets/marketplace.json")
          abi = abi.default
          let marketplaceContract = new state.web3.eth.Contract(abi, state.constants.contract)
          let result = await marketplaceContract.methods.memberExists(new state.web3.utils.BN(payload.tokenId)).call()
          resolve(result)
        }
        catch(err){
          reject(err)
        }
      })
    },
    //payload: tokenId, assetAmount
    addMember({state}, payload){
      return new Promise(async (resolve, reject) => { 
        try{
          debugger
          let from = state.profile[0]
          let abi = await import("@/assets/marketplace.json")
          abi = abi.default
          let marketplaceContract = new state.web3.eth.Contract(abi, state.constants.contract)
          let result = await marketplaceContract.methods.addMember(new state.web3.utils.BN(payload.tokenId), state.web3.utils.toWei(new state.web3.utils.BN(payload.assetAmount))).send({from: from})
          resolve(result)
        }
        catch(err){
          reject(err)
        }
      })
    },
    // payload: tokenId
    removeMember({state, dispatch}, payload){
      return new Promise(async (resolve, reject) => { 
        try{
          let membership = await dispatch("isMember", payload['tokenId'])
          membership = Object.values(membership)[0]
          if (!membership) { resolve()}
          let from = state.profile[0]
          let abi = await import("@/assets/marketplace.json")
          abi = abi.default
          let marketplaceContract = new state.web3.eth.Contract(abi, state.constants.contract)
          let result = await marketplaceContract.methods.removeMember(new state.web3.utils.BN(payload.tokenId)).send({from: from})
          resolve(result)
        }
        catch(err){
          reject(err)
        }
      })
    },
    challenge({state, dispatch}, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let from = state.profile[0]
          let abi = await import("@/assets/marketplace.json")
          abi = abi.default
          let marketplaceContract = new state.web3.eth.Contract(abi, state.constants.contract)
          // generate a random number in the smart contract representing oracle decision
          let seed = Math.floor(0 + (Math.random() * (100 - 0 + 1)));
          debugger
          await marketplaceContract.methods.getRandomNumber(new state.web3.utils.BN(seed)).send({from: from})
          let result = await marketplaceContract.methods.challengeMember(new state.web3.utils.BN(payload.tokenId), from).send({from: from})
          resolve(result)

        }
        catch(err) {
          reject(err)
        }
      })
    }
  },

}
const meta = {
  namespaced: true,
  state: () => ({
    brands: ['Walmart']
  }),
}
const CardNFT = {
  namespaced: true,
  state: () => ({
    ChargedParticle: null
  }),
  mutations: {
    setChargedParticle(state, payload) {
      state.ChargedParticle = payload
    }
  },
  actions: {
    loadChargedParticle({ commit }) {
      new window.web3.eth.Contract(ABI, contractAddress);

    }
  }

}
export default new Vuex.Store({
  modules: {
    ethereum: ethereum,
    meta: meta,
    document: document,
  }
})

// export default new Vuex.Store({
//   state: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
